import { prefixClass } from 'lib/utils';
import classNames from 'classnames';
import './Queue.scss';
import BrowserColumn from './BrowserColumn';
import QueueDetails from './QueueDetails/QueueDetails';

type QueueProps = {
  /** Whether the queue is visible or hidden */
  visible?: boolean;
  /** Whether the queue should display in full screen mode */
  fullScreen?: boolean;
};

/**
 * Queue component that displays the main interface for handling customer requests.
 * It consists of two main sections: a browser column for selecting requests and a
 * details panel for viewing and interacting with the selected request.
 *
 * @param {QueueProps} props - The component props
 * @param {boolean} [props.visible=true] - Whether the queue is visible or hidden
 * @param {boolean} [props.fullScreen=false] - Whether the queue should display in full screen mode
 * @returns {JSX.Element} The rendered Queue component
 */
const Queue = ({ visible = true, fullScreen = false }: QueueProps): JSX.Element => {
  const prefix = prefixClass('queue');

  return (
    <div className={classNames(prefix(), { 'queue-visible': visible, 'full-screen': fullScreen })}>
      <div className={prefix('browser')}>
        <BrowserColumn />
      </div>
      <QueueDetails />
    </div>
  );
};

export default Queue;
